import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { api } from '../api/client'

export default function CreditsBadge() {
  const [credits, setCredits] = useState(null)
  const location = useLocation()
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register'
  useEffect(() => {
    if (isAuthPage) return
    api.get('/me/credits').then((r) => setCredits(r.data)).catch(() => setCredits(null))
  }, [isAuthPage, location.pathname])
  if (isAuthPage || credits == null) return null
  return (
    <div className="fixed bottom-20 right-16 z-40 md:bottom-6 md:right-16">
      <Link
        to="/dashboard/buy-credits"
        className="flex items-center gap-2 rounded-xl border border-white/20 bg-studio-bg/95 px-4 py-2.5 text-sm font-medium text-white shadow-lg backdrop-blur-xl hover:bg-white/10"
      >
        {credits.unlimited ? 'Credits: ∞' : `Credits: ${credits.balance}`}
        <span className="text-white/60 text-xs">(bestellen)</span>
      </Link>
    </div>
  )
}
